export default __webpack_public_path__ + "static/media/next-arrow.09a313af.svg";